const fillZero = (hrs: number) => {
  return hrs < 10 ? `0${hrs}` : `${hrs}`;
};

export const formatNumToTime = (num) => {
  if(!num && num <= 0 ) return '00:00';
  if(num === 1440) return '23:59';
  
  return `${fillZero(Math.floor(num / 60))}:${fillZero(Math.floor(num % 60))}`;
};

export const formatTimeNoColon = (num) => {
  const formatedTime = formatNumToTime(num);
  return formatedTime ? formatedTime.split(':').join('') : 0;
}

export const formatTimeToNum = (time) => {
  if(!time.includes(':')) return Number(time)*60;
  else {
    let hh = time.split(':')[0];
    let mm = time.split(':')[1];
    if(hh.length === 1) hh = fillZero(hh);
    if(mm.length === 1) mm = mm + '0';
    return Number(hh)*60 + Number(mm);
  }
}

export const checkNegativeDeviation = (val) => {
  if(val === 0){
    return false;
  }
  let deviation = val.toString().split('')[0];
  if(deviation === "-"){
    return true;
  }else{
    return false;
  }
}

export const getDeviationValue = (val) => {
  if(checkNegativeDeviation(val)){
    return "-"+formatNumToTime(Number(val.toString().slice(1)));
  }else{
    return "+"+formatNumToTime(val);
  }
}